/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Form_Clients_Empty_Selection_DescriptionInputs */

const en_users_form_clients_empty_selection_description = /** @type {(inputs: Users_Form_Clients_Empty_Selection_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use the client search above to associate this user with one or more clients.`)
};

const pt_br2_users_form_clients_empty_selection_description = /** @type {(inputs: Users_Form_Clients_Empty_Selection_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use a busca de clientes acima para associar este usuário a um ou mais clientes.`)
};

/**
* | output |
* | --- |
* | "Use the client search above to associate this user with one or more clients." |
*
* @param {Users_Form_Clients_Empty_Selection_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_form_clients_empty_selection_description = /** @type {((inputs?: Users_Form_Clients_Empty_Selection_DescriptionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Form_Clients_Empty_Selection_DescriptionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_form_clients_empty_selection_description(inputs)
	return pt_br2_users_form_clients_empty_selection_description(inputs)
});